import BaseUISystem from '../BaseUISystem';
import BaseMenu from './BaseMenu';
import { ConnectFbPopupLayout } from '../../../Layouts/ConnectToFacebook/ConnectFbPopupLayout';
import { PopupID } from '../../../State/UI/PopupID';
import { Layout } from '../../../Utility/layout/createLayout';
import Game from 'Game';
import TransformComponent from 'Component/Transform';
import PIXIRenderer from 'System/Render/PIXIRenderer';
import RenderSystem, { RenderSystemEvent } from 'System/Render/RenderSystem';
import { UIActions } from 'State/UI/UIActions';
import { GameObjectEvent } from 'GameObject/GameObject';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { PlatformActions } from 'State/Game/PlatformActions';
import { isNative } from 'Utility/Platform';
import { SignInState } from 'State/Game/SignInState';
import { AuthPlatform } from '@softgames/mobile-dev-tools';

export default class ConnectFbPopup extends BaseMenu {
    private layout: any;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.CONNECT_FB_POPUP, uiSystem, false);
    }

    public static canShow(): boolean {
        return !Game.sdk.isFacebookConnected() && isNative();
    }

    public async preload(): Promise<void> {
        Game.resource.add('connect-fb-popup', 'resource/graphics/sprite_sheets/connect-fb-popup.json');
    }

    public onCreate() {
        super.onCreate();

        this.layout = new ConnectFbPopupLayout();
        this.element.addChild(this.layout.root);
        this.element.container.resize = () => void 0;

        this.layout.connectButton.on(GameObjectEvent.SELECTED, this.handleConnectClick);
        this.layout.closeButton.on(GameObjectEvent.SELECTED, this.handleCloseClick);

        [this.layout.closeButton, this.layout.connectButton].forEach(button => {
            applyDefaultButtonAnimation(button);
        });

        RenderSystem.on(RenderSystemEvent.RESIZE, this.handleResize);
        this.handleResize();
    }

    public onHide(params?: any): void {
        super.onHide(params);
        RenderSystem.off(RenderSystemEvent.RESIZE, this.handleResize);
    }

    private readonly handleConnectClick = async (): Promise<void> => {
        await Game.store.dispatch(PlatformActions.signIn(AuthPlatform.Facebook, false, true));

        if (Game.store.getState().platform.signInState === SignInState.SignedIn) {
            UIActions.hidePopup(PopupID.CONNECT_FB_POPUP);
        }
    };

    private readonly handleCloseClick = (): void => {
        UIActions.hidePopup(PopupID.CONNECT_FB_POPUP);
    };

    private handleResize = (): void => {
        const rootTransform = this.layout.root.getComponent(TransformComponent);
        const groundTransform = this.layout.ground.getComponent(TransformComponent);

        rootTransform.x = PIXIRenderer.renderer.width / 2;
        rootTransform.y = PIXIRenderer.renderer.height / 2;
        groundTransform.y = PIXIRenderer.renderer.height / 2;
        groundTransform.scale.set((PIXIRenderer.renderer.width / groundTransform.width) * groundTransform.scale.x);
    };
}
